import { defineComponent as _defineComponent } from 'vue'
import { normalizeClass as _normalizeClass, createVNode as _createVNode, withModifiers as _withModifiers, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = ["disabled"]

import { ref } from 'vue'

import Icon from '@/components_new/Icon/Icon.vue'
import Tooltip from '@/components_new/Tooltip.vue'


export default /*@__PURE__*/_defineComponent({
  __name: 'LogoutButton',
  emits: ["logout"],
  setup(__props, { emit: __emit }) {

const disabledLogout = ref(false)
const emit = __emit

function logout() {
    if (disabledLogout.value) {
        return
    }
    disabledLogout.value = true

    emit('logout')
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(Tooltip, {
    content: _ctx.$tr('userProfile.logout')
  }, {
    default: _withCtx(() => [
      _createElementVNode("button", {
        disabled: disabledLogout.value,
        class: _normalizeClass(_ctx.$style.logout_button),
        "data-interface-target": "logout",
        onClick: _withModifiers(logout, ["stop","prevent"])
      }, [
        _createVNode(Icon, {
          name: "logout",
          class: _normalizeClass([_ctx.$style.logout_icon, disabledLogout.value && _ctx.$style.disabled])
        }, null, 8, ["class"])
      ], 10, _hoisted_1)
    ]),
    _: 1
  }, 8, ["content"]))
}
}

})